@import '../../utils/focus-ring.css';
@import '../../utils/control-inactive.css';
@import '../../utils/forced-colors.css';

:host {
  --ds-switch-width: var(--dimension-size-400);
  --ds-switch-height: var(--dimension-size-250);
  --ds-switch-thumb-size: var(--dimension-size-150);
  --ds-switch-gap: var(--dimension-space-050);
  --ds-switch-stroke: var(--dimension-stroke-width-012);
  --ds-switch-inset: var(--ds-switch-gap);
  --ds-switch-thumb-hover: var(--color-interaction-hover);
  --ds-switch-thumb-pressed: var(--color-interaction-pressed);
  --ds-switch-travel: calc(
    var(--ds-switch-width) - var(--ds-switch-thumb-size) - var(--ds-switch-inset) -
      var(--ds-switch-inset)
  );
  position: relative;
  display: inline-flex;
  width: var(--ds-switch-width);
  height: var(--ds-switch-height);
  padding: 0;
  border: none;
  border-radius: var(--dimension-radius-half);
  box-sizing: border-box;
  flex-shrink: 0;
  overflow: visible;
  cursor: default;
  user-select: none;
  outline: none;
  background-color: transparent;
  box-shadow: inset 0 0 0 var(--ds-switch-stroke) var(--color-border-secondary);
  transition:
    background-color var(--effect-motion-short-3),
    box-shadow var(--effect-motion-short-3);
}

:host(.switch--lg) {
  --ds-switch-width: var(--dimension-size-500);
  --ds-switch-height: var(--dimension-size-300);
  --ds-switch-thumb-size: var(--dimension-iconography-sm);
  --ds-switch-gap: var(--dimension-space-050);
}

:host(.switch--sm) {
  --ds-switch-width: var(--dimension-size-300);
  --ds-switch-height: var(--dimension-size-200);
  --ds-switch-thumb-size: calc(var(--dimension-size-base) * 5 / 4);
  --ds-switch-gap: calc(var(--dimension-space-025) + var(--dimension-space-012));
}

:host(.switch--xs) {
  --ds-switch-width: var(--dimension-size-250);
  --ds-switch-height: var(--dimension-size-150);
  --ds-switch-thumb-size: var(--dimension-size-100);
  --ds-switch-gap: var(--dimension-space-025);
}

:host(.checked) {
  background-color: var(--color-background-bold-brand);
  box-shadow: none;
}

:host(.switch--readonly),
:host(.switch--presentation) {
  cursor: default;
}

:host(.switch--presentation) {
  pointer-events: none;
}

/* Inactive: `.ds-control-inactive` (50% opacity). */

.thumb {
  position: absolute;
  top: 50%;
  left: var(--ds-switch-inset);
  width: var(--ds-switch-thumb-size);
  height: var(--ds-switch-thumb-size);
  border-radius: var(--dimension-radius-half);
  background-color: var(--color-foreground-tertiary);
  box-shadow: none;
  transform: translateY(-50%);
  transition:
    background-color var(--effect-motion-short-3),
    transform var(--effect-motion-short-3);
  pointer-events: none;
}

.thumb::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: transparent;
  pointer-events: none;
}

@media (hover: hover) and (pointer: fine) {
  :host(:hover:not(:disabled):not(.ds-control-inactive):not(.switch--readonly):not(.switch--presentation))
    .thumb::after {
    background: var(--ds-switch-thumb-hover);
  }
}

:host(:active:not(:disabled):not(.ds-control-inactive):not(.switch--readonly):not(.switch--presentation))
  .thumb::after {
  background: var(--ds-switch-thumb-pressed);
}

:host(.checked) .thumb {
  background-color: var(--color-background-primary);
  box-shadow: none;
  transform: translate3d(var(--ds-switch-travel), -50%, 0);
}

@media (prefers-reduced-motion: reduce) {
  :host {
    transition: none;
  }

  .thumb {
    transition: none;
  }
}

@media (forced-colors: active) {
  :host {
    border: var(--ds-switch-stroke) solid var(--ds-forced-color-content);
    box-shadow: none;
  }

  :host(.checked) {
    background-color: var(--ds-forced-color-selected);
    border-color: var(--ds-forced-color-selected);
  }

  .thumb {
    background-color: var(--ds-forced-color-content);
  }

  :host(.checked) .thumb {
    background-color: var(--ds-forced-color-on-selected);
  }
}
